<script lang="ts">
	import { Section, type SectionTheme } from "#lib/web-ui/primitives/index.js";
	import { Button } from "#lib/web-ui/ui/button/index.js";

	interface Props {
		displayName: string;
		title: string;
		photoUrl: string;
		quote: string;
		phoneLabel: string;
		phoneDisplay: string;
		phoneHref: string;
		phoneButtonLabel: string;
		emailLabel: string;
		email: string;
		emailButtonLabel: string;
		webLabel: string;
		siteUrl: string;
		theme?: SectionTheme;
		id?: string;
		class?: string;
	}

	let {
		displayName,
		title,
		photoUrl,
		quote,
		phoneLabel,
		phoneDisplay,
		phoneHref,
		phoneButtonLabel,
		emailLabel,
		email,
		emailButtonLabel,
		webLabel,
		siteUrl,
		theme = "dark",
		id,
		class: className
	}: Props = $props();

	const siteHost = $derived(siteUrl.replace(/^https?:\/\//, "").replace(/\/$/, ""));
</script>

<Section {theme} {id} class={className} data-testid="associate-contact-card">
	<div class="mx-auto flex max-w-4xl flex-col gap-8 md:flex-row md:items-start md:gap-12">
		<img
			src={photoUrl}
			alt={displayName}
			class="border-primary h-36 w-36 flex-shrink-0 rounded-full border-4 object-cover"
			width="144"
			height="144"
			loading="lazy"
		/>
		<div class="flex min-w-0 flex-1 flex-col gap-6">
			<div class="flex flex-col gap-1">
				<p class="text-foreground text-2xl font-semibold tracking-tight">{displayName}</p>
				<p class="text-muted-foreground text-sm font-semibold">{title}</p>
			</div>
			<p class="text-muted-foreground text-lg text-pretty">{quote}</p>
			<dl class="border-border grid grid-cols-[auto_1fr] gap-x-6 gap-y-3 border-t pt-6">
				<dt class="text-muted-foreground text-sm">{phoneLabel}</dt>
				<dd>
					<a
						href={phoneHref}
						class="text-foreground decoration-primary font-semibold underline underline-offset-4"
					>
						{phoneDisplay}
					</a>
				</dd>
				<dt class="text-muted-foreground text-sm">{emailLabel}</dt>
				<dd class="min-w-0">
					<a
						href="mailto:{email}"
						class="text-foreground decoration-primary font-semibold break-all underline underline-offset-4"
					>
						{email}
					</a>
				</dd>
				<dt class="text-muted-foreground text-sm">{webLabel}</dt>
				<dd>
					<a
						href={siteUrl}
						class="text-foreground decoration-primary font-semibold underline underline-offset-4"
					>
						{siteHost}
					</a>
				</dd>
			</dl>
			<div class="flex flex-col gap-3 sm:flex-row">
				<Button href={phoneHref} size="lg" class="h-12 px-6 text-base font-semibold">
					{phoneButtonLabel}
					{phoneDisplay}
				</Button>
				<Button
					href="mailto:{email}"
					variant="outline"
					size="lg"
					class="text-foreground h-12 px-6 text-base font-semibold"
				>
					{emailButtonLabel}
				</Button>
			</div>
		</div>
	</div>
</Section>
